import Header from "../layout/Header";
import Footer from "../layout/Footer";
import { useSEO } from "../hooks/useSEO";

export default function AboutPage() {
  useSEO({
    title: "About Vastavik — Real, True & Authentic Media Verification",
    description:
      "VASTAVIK means real, true and actual in Sanskrit. Built to help people verify authentic media, fight deepfakes and protect against misinformation.",
    path: "/about",
    keywords:
      "About Vastavik, media authenticity company, deepfake protection, content provenance",
  });

  return (
    <div className="min-h-screen bg-white text-black flex flex-col">
      <Header />

      <main className="flex-1 flex justify-center px-5 md:px-10">
        <section className="about-section">
          <h1 className="about-title">About</h1>

          <p className="about-description">
            <span className="about-highlight">VASTAVIK</span> is a Sanskrit word
            which means{" "}
            <span className="about-highlight">real, true, and actual</span>. In
            today’s world, discerning what is authentic and what is not has
            become increasingly difficult. Vastavik was created to address this
            challenge — born from the idea of helping people distinguish the
            real from the fabricated, protecting individuals from manipulation,
            exploitation, and misinformation. It offers a simple and effective
            way for anyone to verify what is genuinely “Vastavik” and what is
            not.
          </p>

          <div className="about-founder">
            <p className="about-founder-name">Gajendra Singh</p>
            <p className="about-founder-role">CEO &amp; Founder</p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}